/**
 * English default titles produced by the server's getDefaultTitle().
 * When `bot_content.source_name` matches one of these, the UI should fall
 * back to a localized type label instead of showing the raw English string.
 *
 * Singular variants ('Google Sheet', 'Google Doc') exist in legacy rows.
 */
export const SERVER_DEFAULT_TITLES: ReadonlySet<string> = new Set([
  'Text',
  'Clarification Answer',
  'Uploaded File',
  'Uploaded Image',
  'Web Page',
  'Google Sheets',
  'Google Docs',
  'Google Sheet',
  'Google Doc',
  'Content',
]);

/**
 * Strip a trailing " (https://...)" URL suffix the server sometimes appends
 * to source_name (e.g. "Page Title (https://example.com)").
 */
export function stripUrlSuffix(title: string): string {
  const i = title.indexOf(' (http');
  return i > 0 ? title.substring(0, i) : title;
}
